import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import moment from 'vue-moment'
import i18n from './i18n'

window.axios = axios;

axios.interceptors.response.use(function (response) {
    // Do something with response data
    if (response.data.errors && response.data.errors.length) {
        return Promise.reject(response.data);
    }
    return response;
}, function (error) {
    // Do something with response error
    return Promise.reject(error.response);
});

Vue.config.productionTip = false
Vue.use(moment);
new Vue({
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app')
